module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bHFx6"))).then(() => parcelRequire('d0iPb'));